import { render, staticRenderFns } from "./CustomUpload.vue?vue&type=template&id=15e82803&scoped=true"
import script from "./CustomUpload.vue?vue&type=script&lang=js"
export * from "./CustomUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomUpload.vue?vue&type=style&index=0&id=15e82803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e82803",
  null
  
)

export default component.exports